export const surveyCount = `
query SurveyCount {
  managementStats {
    user {
      survey {
        searchEngine
        referral
        emailNewsletter
        whatsappOrBroadcast
        telegram
        facebook
        instagram
        linkedIn
        youTube
        other
        notChoose
      }
    }
  }
}
`